module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-white-2-b3bfe23db938fa91aadb64a9a0a3f8ba.webp";